import { RouteConfig } from "vue-router";

const usuarios: RouteConfig = {
  path: "/usuarios",
  name: "usuarios",
  component: () => import(/* webpackChunkName: "usuarios" */ "@/views/Usuarios.vue"),
};

export default usuarios;
